export enum OnboardingProcessStatusEnum {
    WAIT_APPLICATION_SUBMISSION = 'wait_application_submission',
    IN_PROGRESS = 'in_progress',
    NEED_ADDITIONAL_INFO = 'need_additional_info',
    REVIEW_AND_SIGN_NEEDED = 'review_and_sign_needed',
    REVIEW_AND_SIGN_IN_PROGRESS = 'review_and_sign_in_progress',
    DOCUSIGN_IN_PROGRESS = 'docusign_in_progress',
    COMPLETED = 'completed',
    REJECTED = 'rejected'
}
